var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: "请输入检查结果",
        okText: "确认",
        cancelText: "取消",
        width: "1300px",
        visible: _vm.visible,
        "confirm-loading": _vm.confirmLoading,
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [_c("index3-dialog", { on: { change: _vm.changeName } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }